import * as store from '@daas-consulting/core-frontend-store';
import {
  AuditModel,
  Filter,
} from '@daas-consulting/security/audit/frontend/models';
import { context, feature } from '../audit.const';

const getItemActions = store.getActionsNames({
  context,
  feature,
  section: store.SectionsNames.detailPreview,
  action: store.DetailPreviewActionNames.getItem,
});

export class GetItem {
  static readonly type = `${getItemActions.action}`;
  constructor(readonly payload: Filter) {}
}

export class GetItemRequest {
  static readonly type = `${getItemActions.request}`;
}

export class GetItemSuccessful {
  static readonly type = `${getItemActions.successful}`;
  constructor(readonly payload: AuditModel) {}
}

export class GetItemFailure {
  static readonly type = `${getItemActions.failure}`;
  constructor(readonly payload: Error) {}
}

export const {
  action: GetHistory,
  failure: GetHistoryFailure,
  request: GetHistoryRequest,
  successful: GetHistorySuccessful,
} = store.getActionsClass<Filter, AuditModel[]>({
  context,
  feature,
  section: store.SectionsNames.detailPreview,
  action: 'get history',
});

export class Reset {
  static readonly type = store.getActionName({
    context,
    feature,
    section: store.SectionsNames.detailPreview,
    action: 'reset',
  });
}

export const {
  action: GetDetail,
  failure: GetDetailFailure,
  request: GetDetailRequest,
  successful: GetDetailSuccessful,
} = store.getActionsClass<Filter, AuditModel[]>({
  context,
  feature,
  section: store.SectionsNames.detailPreview,
  action: 'get detail',
});
